import { formatAppointmentDateTimezone, showDateInUtc, UC_FIRST } from "helpers/common";
import { Button, Modal, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

const EventDetailPopup = ({
  showPopup,
  setShowPopup,
  details,
  schedulerTimezone
}) => {

  const closePopup = () => {
    setShowPopup(false);
  }

  if (!details) {
    return "";
  }

  return (
    <>
      <Form>
        <Modal
          show={showPopup}
          onHide={closePopup}
          backdrop="static"
          keyboard={false}
          centered
          className="FormPop"
        >
          <Modal.Header closeButton>
            <Modal.Title>Google Calendar Event Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <div className="py-2">
                <h5>{details.summary}</h5>
                <p className="fw-bold">
                  {formatAppointmentDateTimezone(details?.start?.dateTime, schedulerTimezone)},{" "}
                  {formatAppointmentDateTimezone(details?.start?.dateTime, schedulerTimezone, "h:mm A")} -{" "}
                  {formatAppointmentDateTimezone(details?.end?.dateTime, schedulerTimezone, "h:mm A")} 
                </p>
                <p>
                  Created on:{` `}
                  <span>
                    {showDateInUtc(details?.created, "dddd MMMM DD, YYYY")}
                  </span>
                </p>
                {details?.description && 
                  <>
                    <p>
                      Description:{` `}
                      <span>{parse(details.description)}</span>
                    </p>
                  </>
                }
                <p>Status: <span className="fw-bold" style={{ color: "#198754" }}>{UC_FIRST(details.status)}</span></p>
                {details?.htmlLink && (
                  <Link
                    to={details?.htmlLink}
                    className="themeClr"
                    target="_blank"
                  >
                    View on Google Calendar
                  </Link>
                )}
            </div>
            
          </Modal.Body>
          
          <Modal.Footer className="FormbtnWrpper d-flex justify-content-between">
            <div>
              <Button
                className="d-flex align-items-center justify-content-center commonBtn btnSm"
                onClick={closePopup}
              >
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </Form >
      
    </>
  );
};

const mapStateToPros = (state) => {
  return {
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(EventDetailPopup);
